<template>
  <div class="xiaobu-container" id="dashboard">
    <div class="station-top">
      <el-row>
        <el-col :span="6">
          <div :class="['top-item-box', 'item-box-one', mixinHasPermi('inventory:entry:list') ? 'pointer' : '']"
            @click="handleGo('inventory:entry:list', 'inventoryEntryManage')">
            <div class="left">
              <div>入库</div>
              <div class="main-num-box"><span class="main-num">{{ entryCompletedNum }}</span></div>
            </div>
            <div class="right">
              <div>待入库：{{ entryWaitNum }}</div>
              <div>已作废：{{ entryInvalidNum }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div :class="['top-item-box', 'item-box-two', mixinHasPermi('inventory:out:list') ? 'pointer' : '']"
            @click="handleGo('inventory:out:list', 'inventoryOutManage')">
            <div class="left">
              <div>出库</div>
              <div class="main-num-box"><span class="main-num">{{ outCompletedNum }}</span></div>
            </div>
            <div class="right">
              <div>待出库：{{ outWaitNum }}</div>
              <div>已作废：{{ outInvalidNum }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div :class="['top-item-box', 'item-box-three', mixinHasPermi('inventory:spuWarning:list') ? 'pointer' : '']"
            @click="handleGo('inventory:spuWarning:list', 'inventorySpuWarningManage')">
            <div class="left">
              <div>库存预警</div>
              <div class="main-num-box"><span class="main-num">{{ inventoryWarningQuantity }}</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div :class="['top-item-box', 'item-box-four', mixinHasPermi('inventory:expireWarning:list') ? 'pointer' : '']"
            @click="handleGo('inventory:expireWarning:list', 'inventoryExpireWarningManage')">
            <div class="left">
              <div>过期预警</div>
              <div class="main-num-box"><span class="main-num">{{ expireWarningNum }}</span></div>
            </div>
            <div class="right">
              <div>正常数：{{ normalNum }}</div>
              <div>已过期：{{ expireNum }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div v-if="openAdvertisingSpace" id="stationAd" class="dashboard-station-ad">
      <!-- <union-ad id="u6999072"></union-ad> -->
    </div>

    <div class="station-middle">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <div class="card-title">仓库货物占比</div>
            <div class="card-content">
              <warehouse-pie ref="warehousePieRef"></warehouse-pie>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div class="card-title">生产入库趋势</div>
            <div class="card-content">
              <entry-bar ref="entryBarRef"></entry-bar>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="station-bottom">
      <el-row>
        <el-col :span="6">
          <el-card class="box-card">
            <div class="card-title">近7日销售出库</div>
            <div class="card-content">
              <line-one ref="lineOneRef"></line-one>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div class="card-title">近7日过期出库</div>
            <div class="card-content">
              <line-two ref="lineTwoRef"></line-two>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div class="card-title">近7日移库</div>
            <div class="card-content">
              <line-three ref="lineThreeRef"></line-three>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div class="card-title">近7日退货入库</div>
            <div class="card-content">
              <line-four ref="lineFourRef"></line-four>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { statisticsApi } from "@/api"
import WarehousePie from "./dashboard-components/warehouse-pie.vue"
import EntryBar from "./dashboard-components/entry-bar.vue"
import LineOne from "./dashboard-components/line-one.vue"
import LineTwo from "./dashboard-components/line-two.vue"
import LineThree from "./dashboard-components/line-three.vue"
import LineFour from "./dashboard-components/line-four.vue"
import { debounce, uuid } from "vue2-element-admin-plugin"
export default {
  components: {
    WarehousePie,
    EntryBar,
    LineOne,
    LineTwo,
    LineThree,
    LineFour
  },
  data() {
    return {
      entryCompletedNum: 0, // 入库单完成数量
      entryInvalidNum: 0, // 入库单作废数量
      entryWaitNum: 0, // 入库单待入库数量
      outCompletedNum: 0, // 出库单完成数量
      outInvalidNum: 0, // 出库单作废数量
      outWaitNum: 0, //出库单待出库数量
      inventoryWarningQuantity: 0, // 库存预警数量
      expireNum: 0, // 过期数量
      expireWarningNum: 0, // 过期预警数量
      normalNum: 0 // 正常数量
    }
  },
  computed: {
    openAdvertisingSpace() {
      return this.$store.getters.openAdvertisingSpace
    }
  },
  watch: {
    openAdvertisingSpace: {
      handler: function(val) {
        if (val) {
          // 加载百度广告
          this.loadBaiduAdAsync()
        }
      },
      immediate: true
    }
  },
  created() {
    this.getDashboardData()
  },
  mounted() {
    // 监听元素大小变化
    const element = document.getElementById("dashboard")
    const observer = new ResizeObserver(entries => {
      // for (const entry of entries) {
      //   const width = entry.contentRect.width
      //   console.log(`Element width: ${width}px`)
      // }
      this.resize()
    })

    observer.observe(element)

    //清除监听
    this.$once("hook:beforeDestroy", () => {
      // 停止观察
      observer.disconnect()
    })
  },
  methods: {
    /**
     * 加载百度广告
     * id值从百度联盟后台获取
     */
    loadBaiduAdAsync() {
      this.$nextTick(() => {
        // 获取绑定了 ref 的父元素
        const parentElement = document.getElementById("stationAd")
        // 清除元素内容
        parentElement.innerHTML = ""

        const className = uuid()

        // 创建一个新的元素
        const newElement = document.createElement("div")
        newElement.className = className // 添加类名
        newElement.innerHTML = `<div class="loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div>`

        // 将新元素添加到父元素中
        parentElement.appendChild(newElement);
        (window.slotbydup = window.slotbydup || []).push({
          id: "u6999072",
          container: className,
          async: true
        })
      })
    },
    // 重新绘制echarts
    resize: debounce(function(val) {
      this.$refs.warehousePieRef && this.$refs.warehousePieRef.resize()
      this.$refs.entryBarRef && this.$refs.entryBarRef.resize()
      this.$refs.lineOneRef && this.$refs.lineOneRef.resize()
      this.$refs.lineTwoRef && this.$refs.lineTwoRef.resize()
      this.$refs.lineThreeRef && this.$refs.lineThreeRef.resize()
      this.$refs.lineFourRef && this.$refs.lineFourRef.resize()
    }, 300),
    // 跳转对应页面
    handleGo(permission, name) {
      if (!this.mixinHasPermi([permission])) {
        return
      }
      this.$router.push({ name })
    },
    // 获取顶部数据
    getDashboardData() {
      statisticsApi.getDashboardData().then(res => {
        this.entryCompletedNum = res.entryCompletedNum
        this.entryInvalidNum = res.entryInvalidNum // 入库单作废数量
        this.entryWaitNum = res.entryWaitNum // 入库单待入库数量
        this.outCompletedNum = res.outCompletedNum // 出库单完成数量
        this.outInvalidNum = res.outInvalidNum // 出库单作废数量
        this.outWaitNum = res.outWaitNum //出库单待出库数量
        this.inventoryWarningQuantity = res.inventoryWarningQuantity // 库存预警数量
        this.expireNum = res.expireNum // 过期数量
        this.expireWarningNum = res.expireWarningNum // 过期预警数量
        this.normalNum = res.normalNum // 正常数量
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.xiaobu-container {
  padding: 16px 12px !important;
  padding-bottom: 4px !important;
  .dashboard-station-ad {
    width: calc(100% - 12px);
    border-radius: 4px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 12px;
    background: #fff;
    &:empty {
      margin-bottom: 0;
    }
    ::v-deep .loading-spinner {
      margin: 0;
      height: 94px;
      width: 100%;
      text-align: center;
      .circular {
        margin-top: 26px;
        height: 42px;
        width: 42px;
        -webkit-animation: loading-rotate 2s linear infinite;
        animation: loading-rotate 2s linear infinite;
        .path {
          -webkit-animation: loading-dash 1.5s ease-in-out infinite;
          animation: loading-dash 1.5s ease-in-out infinite;
          stroke-dasharray: 90, 150;
          stroke-dashoffset: 0;
          stroke-width: 2;
          stroke: #409EFF;
          stroke-linecap: round;
        }
      }
    }
  }

  ::v-deep .station-top {
    .el-col {
      padding: 0 6px;

      .top-item-box {
        height: 128px;
        background: #fff;
        margin-bottom: 12px;
        border-radius: 12px;
        color: #fff;
        padding: 16px;
        display: flex;

        &.pointer {
          cursor: pointer;
        }

        &.item-box-one {
          background: linear-gradient(30deg, #1a94db, #4db1eb, #7acaf9);
          box-shadow: 0 4px 12px #8ed2fa;
        }

        &.item-box-two {
          background: linear-gradient(30deg, #c7a327, #d5ba47, #e3cf65);
          box-shadow: 0 4px 12px #ece7cd;
        }

        &.item-box-three {
          background: linear-gradient(30deg, #6365f7, #9177f1, #cd8ee9);
          box-shadow: 0 4px 12px #dcc9e6;
        }

        &.item-box-four {
          background: linear-gradient(30deg, #ed3a60, #f1557a, #f67da0);
          box-shadow: 0 4px 12px #e7cfd6;
        }

        .left {
          flex: 2 1 0%;
          height: 100%;

          .main-num-box {
            text-align: center;
            margin-top: 24px;

            .main-num {
              font-size: 26px;
              font-weight: bold;
            }
          }
        }

        .right {
          flex: 3 1 0%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
        }
      }
    }
  }

  ::v-deep .station-middle,
  ::v-deep .station-bottom {
    .el-col {
      padding: 0 6px;

      .box-card {
        height: 400px;
        margin-bottom: 12px;
        background-color: #fff;
        border-color: #ebe6f5;

        .el-card__body {
          height: 100%;

          .card-title {
            font-weight: 700;
            height: 30px;
            display: flex;
            align-items: center;

            &:before {
              content: "";
              height: 70%;
              width: 5px;
              background: #3671e8;
              margin-right: 8px;
            }
          }

          .card-content {
            width: 100%;
            height: calc(100% - 30px);
          }
        }
      }
    }
  }
}
</style>
